/* eslint-disable complexity */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';
import { DISPATCH_METHOD_TARGET } from '~redux/SearchStore/constants';

import Address from './components/Address';
import DispatchMethods from './components/DispatchMethods';
import styles from './styles.module.scss';

const Actionlinks = () => {
  const dispatch = useDispatch();
  const handleOpenDAPModal = () => dispatch(ModalActions.openModal(MODALS.DELIVERY_OR_PICKUP));
  const dispatchType = useSelector((state) => state.searchStore[DISPATCH_METHOD_TARGET]);
  const address = useSelector((state) => state.auth.address?.current?.textAddress);
  const currentSubsidiary = useSelector((state) => state.searchStore.currentSubsidiary?.name);
  const { templateModel } = useSelector((state) => state.core);

  return (
    <div className={`center row middle ${styles.actionLinksContainer}`}>
      <div className={styles.innerContainer}>
        <div className={`row middle ${styles.fixedAddress}`}>
          <div className={`row middle ${styles.dispatchContainer}`}>
            <DispatchMethods
              address={address}
              dispatchType={dispatchType}
              handleOpenDAPModal={handleOpenDAPModal}
            />
          </div>
        </div>
        <Address
          templateModel={templateModel}
          address={address}
          handleOpenDAPModal={handleOpenDAPModal}
          currentSubsidiary={currentSubsidiary}
          dispatchType={dispatchType}
        />
      </div>
    </div>
  );
};

export default Actionlinks;
